import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-100 text-neutral-800 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/f2bd418b0bfbfafabfbde3d1f67690ab/be3b795cf577578dc84a4afcd48bbd61.png"
              alt="Olhar Criativo Logo"
              className="h-28 w-auto mb-6"
            />
            <p className="text-neutral-600 leading-relaxed mb-6">
              {t('footer.descricao')}
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-black/10 rounded-full hover:bg-black/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl text-neutral-800"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-black/10 rounded-full hover:bg-black/20 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl text-neutral-800"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-black/10 rounded-full hover:bg-black/20 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl text-neutral-800"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.servicos')}</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#servicos"
                  className="text-neutral-600 hover:text-black transition-colors cursor-pointer"
                >
                  {t('servicos.gestaoRedes')}
                </a>
              </li>
              <li>
                <a
                  href="#servicos"
                  className="text-neutral-600 hover:text-black transition-colors cursor-pointer"
                >
                  {t('servicos.producaoConteudo')}
                </a>
              </li>
              <li>
                <a
                  href="#servicos"
                  className="text-neutral-600 hover:text-black transition-colors cursor-pointer"
                >
                  {t('servicos.designGrafico')}
                </a>
              </li>
              <li>
                <a
                  href="#servicos"
                  className="text-neutral-600 hover:text-black transition-colors cursor-pointer"
                >
                  {t('servicos.branding')}
                </a>
              </li>
              <li>
                <a
                  href="#servicos"
                  className="text-neutral-600 hover:text-black transition-colors cursor-pointer"
                >
                  {t('servicos.trafegoPago')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.contacto')}</h4>
            <ul className="space-y-2 text-neutral-600">
              <li className="flex items-start">
                <i className="ri-map-pin-line mt-1 mr-2"></i>
                <span>Algarve, Portugal</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a
                  href="tel:+351963467122"
                  className="hover:text-black transition-colors cursor-pointer"
                >
                  +351 963 467 122
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a
                  href="mailto:geral@olharcriativo.pt"
                  className="hover:text-black transition-colors cursor-pointer"
                >
                  geral@olharcriativo.pt
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-black/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-neutral-600">
          <p>
            &copy; {currentYear} Olhar Criativo. {t('footer.direitos')}
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-black transition-colors cursor-pointer mt-4 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
